import { config, EntityType } from 'breeze-client';

/** Appends parameter to url, with appropriate delimiter */
function appendQueryStringParameter(url, parameter) {
    if (!parameter)
        return url;
    var separator = url.endsWith("?") ? "" : url.includes("?") ? "&" : "?";
    return url + separator + parameter;
}
/** Encodes the object into query string parameters */
function encodeParams(obj) {
    var query = '';
    var subValue, innerObj, fullSubName;
    for (var name_1 in obj) {
        if (!obj.hasOwnProperty(name_1)) {
            continue;
        }
        var value = obj[name_1];
        if (value instanceof Array) {
            for (var i = 0; i < value.length; ++i) {
                subValue = value[i];
                fullSubName = name_1 + '[' + i + ']';
                innerObj = {};
                innerObj[fullSubName] = subValue;
                query += encodeParams(innerObj) + '&';
            }
        }
        else if (value && value.toISOString) { // a feature of Date-like things
            query += encodeURIComponent(name_1) + '=' + encodeURIComponent(value.toISOString()) + '&';
        }
        else if (value instanceof Object) {
            for (var subName in value) {
                if (obj.hasOwnProperty(name_1)) {
                    subValue = value[subName];
                    fullSubName = name_1 + '[' + subName + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += encodeParams(innerObj) + '&';
                }
            }
        }
        else if (value === null) {
            query += encodeURIComponent(name_1) + '=&';
        }
        else if (value !== undefined) {
            query += encodeURIComponent(name_1) + '=' + encodeURIComponent(value) + '&';
        }
    }
    return query.length ? query.substr(0, query.length - 1) : query;
}

var UriBuilderJsonAdapter = /** @class */ (function () {
    function UriBuilderJsonAdapter() {
        this.name = "json";
    }
    UriBuilderJsonAdapter.register = function (config$1) {
        config$1 = config$1 || config;
        config$1.registerAdapter("uriBuilder", UriBuilderJsonAdapter);
        return config$1.initializeAdapterInstance("uriBuilder", "json", true);
    };
    UriBuilderJsonAdapter.prototype.initialize = function () { };
    UriBuilderJsonAdapter.prototype.buildUri = function (entityQuery, metadataStore) {
        // force entityType validation;
        var entityType = entityQuery._getFromEntityType(metadataStore, false);
        if (!entityType)
            entityType = new EntityType(metadataStore);
        var json = entityQuery.toJSONExt({ entityType: entityType, toNameOnServer: true });
        json.from = undefined;
        json.queryOptions = undefined;
        if (json.parameters && json.parameters.$data) {
            // remove parameters if doing ajax post
            json.parameters = undefined;
        }
        var jsonString = JSON.stringify(json);
        if (jsonString.length > 2) {
            var urlBody = encodeURIComponent(jsonString);
            return appendQueryStringParameter(entityQuery.resourceName, urlBody);
        }
        else {
            return entityQuery.resourceName;
        }
    };
    return UriBuilderJsonAdapter;
}());
config.registerAdapter("uriBuilder", UriBuilderJsonAdapter);

/**
 * Generated bundle index. Do not edit.
 */

export { UriBuilderJsonAdapter };
//# sourceMappingURL=breeze-client-adapter-uri-builder-json.js.map



//////////////////
// WEBPACK FOOTER
// ./~/breeze-client/fesm5/breeze-client-adapter-uri-builder-json.js
// module id = 855
// module chunks = 0